import Vue from 'vue';
import VTooltip from 'v-tooltip';

// VTooltip.VTooltip.options.autoHide = false
Vue.use(VTooltip);
